import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngToasterComponent } from './kng-toaster.component';
import { KngToasterService } from './kng-toaster.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	declarations: [KngToasterComponent],
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		ToastrModule.forRoot({
			timeOut: 900000,
			positionClass: 'toast-top-right',
			toastClass: 'kng-toast toast-container ngx-toastr',
			enableHtml: true,
			closeButton: true,
			preventDuplicates: true,
			tapToDismiss: false
		})
	],
	exports: [KngToasterComponent],
	providers: [KngToasterService]
})
export class KngToasterModule {}
